<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21 3C21 1.34315 19.6569 0 18 0H3C1.34315 0 0 1.34315 0 3V20C0 21.6569 1.34315 23 3 23H18C19.6569 23 21 21.6569 21 20V3ZM12.5 14.72H17C17.5523 14.72 18 15.1677 18 15.72V19.24L17.9992 19.2815C17.9997 19.2943 18 19.3071 18 19.32C18 19.8281 17.5881 20.24 17.08 20.24H12.42C11.9119 20.24 11.5 19.8281 11.5 19.32L11.5009 19.2823C11.5003 19.2683 11.5 19.2542 11.5 19.24V15.72C11.5 15.1677 11.9477 14.72 12.5 14.72ZM8.58 18.4H3.92C3.4119 18.4 3 18.8119 3 19.32C3 19.8281 3.4119 20.24 3.92 20.24H8.58C9.0881 20.24 9.5 19.8281 9.5 19.32C9.5 18.8119 9.0881 18.4 8.58 18.4ZM3.92 14.72H8.58C9.0881 14.72 9.5 15.1319 9.5 15.64C9.5 16.1481 9.0881 16.56 8.58 16.56H3.92C3.4119 16.56 3 16.1481 3 15.64C3 15.1319 3.4119 14.72 3.92 14.72ZM17.08 11.04H12.42C11.9119 11.04 11.5 11.4519 11.5 11.96C11.5 12.4681 11.9119 12.88 12.42 12.88H17.08C17.5881 12.88 18 12.4681 18 11.96C18 11.4519 17.5881 11.04 17.08 11.04ZM4 7.36H8.5C9.05228 7.36 9.5 7.80772 9.5 8.36V11.88L9.49921 11.9215C9.49973 11.9343 9.5 11.9471 9.5 11.96C9.5 12.4681 9.0881 12.88 8.58 12.88H4C3.44772 12.88 3 12.4323 3 11.88V8.36C3 7.80772 3.44772 7.36 4 7.36ZM17.08 7.36H12.42C11.9119 7.36 11.5 7.7719 11.5 8.28C11.5 8.7881 11.9119 9.2 12.42 9.2H17.08C17.5881 9.2 18 8.7881 18 8.28C18 7.7719 17.5881 7.36 17.08 7.36ZM4 2.76H17C17.5523 2.76 18 3.20772 18 3.76V4.52C18 5.07228 17.5523 5.52 17 5.52H4C3.44772 5.52 3 5.07228 3 4.52V3.76C3 3.20772 3.44772 2.76 4 2.76Z" 
                fill="black"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgNewspaper',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>